import { lStorage } from "utils/storage";
import { LOGIN, SIGNUP, LOGOUT, SHOWLOGIN, RESET } from "../actions/type/login";

const loginState = {
  login: lStorage.get("authInfo")
    ? lStorage.get("authInfo")
    : {
        id: null,
        isUser: false,
        userRole: null,
        name: null,
        email: null,
        avatar: null,
        srcmToken: null,
        tokenData: {
          accessToken: null,
        },
      },
  signup: {
    signupMessage: "React Signup",
  },
  expired: false,
};

export const loginDetails = (state = loginState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        login: action.payload,
      };
    case SIGNUP:
      return { ...state, signup: action.payload };
    case LOGOUT:
      return {
        ...state,
        expired: true,
      };
    case RESET:
      return {
        ...loginState,
      };
    case SHOWLOGIN:
      return {
        ...state,
        login: {
          id: null,
          isUser: false,
          userRole: null,
          name: null,
          email: null,
          avatar: null,
          srcmToken: null,
          tokenData: {
            accessToken: null,
          },
        },
        expired: false,
      };
    default:
      return state;
  }
};
